module.exports = __webpack_public_path__ + "img/a03a5d5.jpg";